import { COLORS, staticLevelData } from "../constants"
import { useState, useEffect } from "react"
import {
    Modal,
    ChooseLevelCard,
    CustomButton,
    ChooseGameCard,
    BackButton
} from "../components"
import styled from "styled-components"
import axios from "axios"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"
import { fireEvent } from "@testing-library/dom"

const StyledCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor};
    width: 60px;
    height: 60px;
    border-radius: 50%;
    color:  ${props => props.color};
`;
const colors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]
export function SelectGamesModal({ modalVisible, onClose, containerheight, isTellFunctionality, inPractice, inTellGamePlay, mode, gameplay, selectedLevelProps }) {
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user);
    const parentUser = useSelector(state => state.auth.user.user);
    const [games, setGamesShown] = useState(false);
    const [data, setData] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const history = useHistory();

    const handleLevelSelect = (selectedLevel) => {
        setSelectedLevel(selectedLevel)
        setGamesShown(true);
    }
    useEffect(async () => {
        if (user.user_role == 1 || user.user_role == 2) {
            const response = await axios.get(`${api}/ps/puchased_games/${parentUser.email}`);
            const data = response.data.levels;
            console.log('test')
            console.log(data)
            setData(data)



        } else {
            if (isTellFunctionality) {
                const response = await axios.get(`${api}/cp/pupil_games_completed/${user.user.pupil_id}`);
                const data = response.data.levels;

                setData(data)
            } else {


                const response = await axios.get(`${api}/pscp/puchased_games/${user.user.pupil_id}`);
                const data = response.data.levels;
                setData(data)

            }
        }
        if (selectedLevelProps) {
            setSelectedLevel(selectedLevelProps)
            setGamesShown(true)
        }

    }, [])

    const handleModalClose = () => {
        setTimeout(() => {
            if (inPractice == false || inTellGamePlay == false) {
                setGamesShown(false)
            }
        }, 500)

        onClose()
    }
    const findIndex = (selectedLevel) => {
        let rememberIndex = 0;
        for (var i = 0; i < 6; i++) {
            if (data[i].level_no == selectedLevel) {
                rememberIndex = i;
                break;
            }
        }
        return rememberIndex;
    }

    return (
        <Modal modalVisible={modalVisible} onClose={handleModalClose}
            containerheight={containerheight}>
            {games && <div style={{ display: 'inline-block', position: 'absolute', top: 15 }}><BackButton text="To Levels" onClick={() => setGamesShown(false)} /></div>}

            {games ?
                <>
                    <h5 className="color-orange text-center">Choose Level {selectedLevel} Games</h5>
                    <div className="d-flex flex-wrap">
                        {data.length != 0 && data[findIndex(selectedLevel)].games.map((entry, i) => {

                            return <ChooseGameCard selectedlevel={selectedLevel} inPractice={inPractice} started={entry.started} completed={entry.completed} gameNumber={entry.game_no} isTellFunctionality={isTellFunctionality} gameplay={gameplay} lastViewed={entry.last_viewed} />
                        })}

                    </div>
                </>
                : <> <h5 className="color-orange text-center">Choose Level</h5>
                    <div className="d-flex flex-wrap">

                        {data.length == 0 && <div className="w-100 text-center">
                            <h6 className="text-center">Currently you have no purchased games</h6>
                            <CustomButton className="mt-2" bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.darker_green} style={{ height: 40, fontSize: 15, width: 150 }} onClick={() => history.replace('/store')}>Buy Games</CustomButton>
                        </div>}
                        {data.length != 0 && data.map((entry, i) => {
                            if (mode == 3) {
                                if (entry.games.length > 0) {
                                    return <ChooseLevelCard key={i} style={{ height: 200 }}>
                                        <StyledCircle bgColor={colors[entry.level_no - 1].bgColor} color={colors[entry.level_no - 1].color}>
                                            <h2 className="mb-0">{entry.level_no}</h2>
                                        </StyledCircle>
                                        <h5 className="mt-2 mb-0">Level {entry.level_no}</h5>
                                        <span className="color-text-grey" style={{ fontSize: 13 }}>{entry.games.length} Games</span>
                                        <CustomButton bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 40, fontSize: 15, width: 130 }} onClick={() => handleLevelSelect(entry.level_no)}>Select</CustomButton>
                                    </ChooseLevelCard>
                                } else {
                                    <div>No Purchased Games</div>
                                }
                            } else if (mode == 2) {
                                if (entry.games.length > 0) {
                                    return <ChooseLevelCard key={data.length + i}>
                                        <StyledCircle bgColor={colors[entry.level_no - 1].bgColor} color={colors[entry.level_no - 1].color}>
                                            <h2 className="mb-0">{entry.level_no}</h2>
                                        </StyledCircle>
                                        <h5 className="mt-2 mb-0">Level {entry.level_no}</h5>
                                        <span className="color-text-grey" style={{ fontSize: 13 }}>{entry.games.length} Games</span>
                                        <CustomButton className="mt-2" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 40, fontSize: 15, width: 100 }} onClick={() => handleLevelSelect(entry.level_no)}>Select</CustomButton>
                                    </ChooseLevelCard>
                                } else {
                                    <div>No Purchased Games</div>
                                }
                            }
                        })}
                    </div>
                </>
            }
        </Modal>
    )
}
SelectGamesModal.defaultProps = {
    isTellFunctionality: true,
};


{/* {mode == 1 && [...Array(6)].map((e, i) => {

                            return <ChooseLevelCard key={i} style={{ height: 250 }}>
                                <StyledCircle bgColor={colors[i].bgColor} color={colors[i].color}>
                                    <h2 className="mb-0">{i + 1}</h2>
                                </StyledCircle>
                                <h5 className="mt-2 mb-0">Level {i + 1}</h5>
                                <span className="color-text-grey" style={{ fontSize: 13 }}>1st game of the level</span>
                                <CustomButton bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.darker_green} style={{ height: 40, fontSize: 15, width: 150 }} onClick={() => {
                                    if (gameplay) {
                                        window.location.replace(`/test_game/${i + 1}/ref?id=V6iBTipO822O`)
                                    } else {
                                        history.replace(`/test_game/${i + 1}/ref?id=V6iBTipO822O`)
                                    }
                                }}>Play</CustomButton>
                                <CustomButton className="mt-2" bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 40, fontSize: 15, width: 150 }} onClick={() => window.location.replace(`/practice/${i + 1}/1?ref=trial`)}>Practice</CustomButton>
                            </ChooseLevelCard>
                        })} */}
